import {
  collection,
  doc,
  getDocs,
  orderBy,
  query,
  updateDoc,
} from 'firebase/firestore';
import { db } from '../firebase';

export type UserRole =
  | 'admin'
  | 'responsible'
  | 'teacher'
  | 'cgs'
  | 'drh'
  | 'UNKNOWN';

export interface UserRow {
  id: string;
  firstName?: string;
  lastName?: string;
  phone?: string;
  email?: string;
  role?: UserRole;
  status?: 'active' | 'inactive';
  createdAt?: Date;
  updatedAt?: Date;
}

const COLLECTION = 'users';

export async function listUsers(): Promise<UserRow[]> {
  const snap = await getDocs(
    query(collection(db, COLLECTION), orderBy('lastName', 'asc'))
  );

  return snap.docs.map((d) => {
    const data = d.data() as any;
    return {
      id: d.id,
      firstName: data.firstName,
      lastName: data.lastName,
      phone: data.phone,
      email: data.email,
      role: (data.role as UserRole | undefined) ?? 'UNKNOWN',
      status: data.status,
      createdAt: data.createdAt?.toDate ? data.createdAt.toDate() : undefined,
      updatedAt: data.updatedAt?.toDate ? data.updatedAt.toDate() : undefined,
    };
  });
}

export async function toggleUserStatus(id: string, current?: string): Promise<void> {
  const ref = doc(db, COLLECTION, id);
  const next = current === 'active' ? 'inactive' : 'active';
  await updateDoc(ref, { status: next });
}

